// src/components/admin/branding/LogoSettings.tsx
import React from 'react';
import { Box, Typography, Grid, TextField } from '@mui/material';
import { Logo } from '../../../system/branding';

interface LogoSettingsProps {
  logo: Logo | undefined;
  onChange: (name: string, value: string | number) => void;
}

const LogoSettings: React.FC<LogoSettingsProps> = ({ logo, onChange }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    onChange(
      name,
      name === 'width' || name === 'height' ? parseInt(value) : value,
    );
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Logo Settings
      </Typography>
      <Typography variant="body2" sx={{ mb: 3 }}>
        Configure your application logo and its display properties.
      </Typography>
      <Grid container spacing={3}>
        <Grid size={12}>
          <TextField
            fullWidth
            name="url"
            label="Logo URL"
            value={logo?.url || ''}
            onChange={handleChange}
            helperText="URL of the logo image (fully qualified URL recommended)"
          />
        </Grid>
        <Grid size={12}>
          <TextField
            fullWidth
            name="altText"
            label="Alt Text"
            value={logo?.altText || ''}
            onChange={handleChange}
            helperText="Alternative text for the logo (for accessibility)"
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <TextField
            fullWidth
            name="width"
            label="Width"
            type="number"
            InputProps={{ inputProps: { min: 0 } }}
            onWheel={(e) => (e.target as HTMLInputElement).blur()}
            onKeyDown={(e) => {
              if (e.key === 'ArrowUp' || e.key === 'ArrowDown')
                e.preventDefault();
            }}
            value={logo?.width || ''}
            onChange={handleChange}
            helperText="Logo width in pixels"
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <TextField
            fullWidth
            name="height"
            label="Height"
            type="number"
            InputProps={{ inputProps: { min: 0 } }}
            onWheel={(e) => (e.target as HTMLInputElement).blur()}
            onKeyDown={(e) => {
              if (e.key === 'ArrowUp' || e.key === 'ArrowDown')
                e.preventDefault();
            }}
            value={logo?.height || ''}
            onChange={handleChange}
            helperText="Logo height in pixels"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default LogoSettings;
